import { render, staticRenderFns } from "./codeCatManage.vue?vue&type=template&id=a7270658&scoped=true"
import script from "./codeCatManage.vue?vue&type=script&lang=js"
export * from "./codeCatManage.vue?vue&type=script&lang=js"
import style0 from "./codeCatManage.vue?vue&type=style&index=0&id=a7270658&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7270658",
  null
  
)

export default component.exports